<template>
  <v-app>
    <v-app-bar dark flat max-height="65">
      <Navbar />
    </v-app-bar>
    <div class="appBody">
      <router-view></router-view>
    </div>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "./components/common/Navbar.vue";
import Footer from "./components/common/Footer.vue";
export default {
  name: "App",
  components: { 
    Navbar,
    Footer
   },
   mounted() {
    document.title = "ACG WoT Lab"
   }
};
</script>
<style>
html {
  min-height: 100%;
  position: relative;
  overflow-y: scroll;
}
.appBody {
  margin-bottom: 180px;
  position:relative;
  height: 100%;
  background-color: #DDDFE3;
}

html::-webkit-scrollbar {
  width: 0px;
  
}
</style>
